export default __webpack_public_path__ + "static/Dorothy-47c3ff8c789cab91bf7b7844d941cab8.png";